import { UtmParameter } from "@/models/utm.entity";
import { MrfiktivUtmDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "utm",
  store
})
export class UtmStore extends VuexModule {
  _utm = new UtmParameter();

  get utm(): MrfiktivUtmDtoGen {
    return this._utm;
  }

  /**
   * True as soon as at least one utm parameter was picked up from the url.
   *
   * Used to keep submissions that carry no campaign information free of an
   * empty utm object.
   */
  get isUtmSet(): boolean {
    return Object.values(this._utm).some((value) => !!value);
  }

  @Mutation
  updateContent(value: string) {
    this._utm.utm_content = value;
  }

  @Action
  setContent(value: string) {
    this.context.commit("updateContent", value);
  }

  @Mutation
  updateTerm(value: string) {
    this._utm.utm_term = value;
  }

  @Action
  setTerm(value: string) {
    this.context.commit("updateTerm", value);
  }

  @Mutation
  updateId(value: string) {
    this._utm.utm_id = value;
  }

  @Action
  setId(value: string) {
    this.context.commit("updateId", value);
  }

  @Mutation
  updateCampaign(value: string) {
    this._utm.utm_campaign = value;
  }

  @Action
  setCampaign(value: string) {
    this.context.commit("updateCampaign", value);
  }

  @Mutation
  updateMedium(value: string) {
    this._utm.utm_medium = value;
  }

  @Action
  setMedium(value: string) {
    this.context.commit("updateMedium", value);
  }

  @Mutation
  updateSource(value: string) {
    this._utm.utm_source = value;
  }

  @Action
  setSource(value: string) {
    this.context.commit("updateSource", value);
  }
}
export const UTMModule = getModule(UtmStore);
